const AvatarSmall = ({img}) => {
    return <img src={img} className="h-12 w-12 rounded-full"></img>;
  };

export {AvatarSmall};